<yc-modal *ngIf="repository && !hide"
  [modalHeader]="isNomination ?
    ('APPLY:hdrStartNewNomination' | ycI18n: 'Start New Nomination') :
    ('APPLY:hdrStartNewApplication' | ycI18n: 'Start New Application')"
  [cancelButtonText]="'common:btnBack' | ycI18n: 'Back'"
  [primaryButtonText]="'common:textStartNew' | ycI18n: 'Start new'"
  (onPrimaryClick)="startNew()"
  (onCancel)="goBack()">

  <div class="mb-4">
    <yc-i18n
      [key]="isNomination ?
        'APPLY:textCopyModalNomHelp' :
        'APPLY:textCopyModalAppHelp2'"
      [context]="{
        'programName': programName
      }"
      [defaultValue]="isNomination ?
        'Start your nomination with a copy of a previously submitted nomination for __programName__ or click \'Start new\' below to start with an empty slate.' :
        'Start your application with a copy of a previously submitted application for __programName__ or click \'Start new\' below to start with an empty slate.'">
    </yc-i18n>
  </div>

  <!-- Available Apps to Copy -->
  <div>
    <yc-scrolling-list *ngIf="repository"
      [hasBorder]="true"
      [repository]="repository"
      [maxHeight]="300">
      <ng-container *ycScrollingListItem="let application;">
        <div>
          <gc-application-slat
            [application]="application"
            [simpleSlat]="true"
            [isCopy]="true"
            (onSelectApplication)="copyApplication(application)">
          </gc-application-slat>
        </div>
      </ng-container>
    </yc-scrolling-list>
  </div>

</yc-modal>